<template>
  <div class="leftbar">
  		<div class="title">
  			个人中心
  		</div>
  		<div class="item" @click="handleNotice()" :class="{'active':rootName=='noticelist' || rootName=='notice'}">
  			<img src="../assets/img/noticeactive.png" v-if="rootName=='noticelist' || rootName=='notice'" >
        <img src="../assets/img/notice.png" v-else >
  			<span class="name">公告</span>
  			<img src="../assets/img/torightactive.png" v-if="rootName=='noticelist' || rootName=='notice'"  >
        <img src="../assets/img/toright.png" v-else >
  		</div>
  		<div class="line">

  		</div>
  		<div class="item" @click="handleMessage()" :class="{'active':rootName=='message' || rootName=='message'}">
  			<img src="../assets/img/messageactive.png" v-if="rootName=='message' || rootName=='message'"  >
         <img src="../assets/img/message.png" v-else >
  			<span class="name">消息</span>
  			<img src="../assets/img/torightactive.png" v-if="rootName=='message' || rootName=='message'"  >
         <img src="../assets/img/toright.png" v-else >
  		</div>
  		<div class="line">

  		</div>
  		<div class="item" @click="handleAbout()" :class="{'active':rootName=='about' || rootName=='about'}">
  			<img src="../assets/img/aboutactive.png" v-if="rootName=='about' || rootName=='about'"  >
         <img src="../assets/img/about.png" v-else >
  			<span class="name">公司简介</span>
  			<img src="../assets/img/torightactive.png" v-if="rootName=='about' || rootName=='about'"  >
        <img src="../assets/img/toright.png" v-else >
  		</div>
  		<div class="line">

  		</div>
  		<div class="item" @click="handleFeedback()" :class="{'active':rootName=='feedback' || rootName=='feedback'}">
  			<img src="../assets/img/feedbackactive.png" v-if="rootName=='feedback' || rootName=='feedback'"  >
         <img src="../assets/img/feedback.png" v-else >
  			<span class="name">意见反馈</span>
  			<img src="../assets/img/torightactive.png" v-if="rootName=='feedback' || rootName=='feedback'"  >
  			<img src="../assets/img/toright.png" v-else >
  		</div>
  		<div class="line">

  		</div>
  		<div class="item" :class="{'active':rootName=='concat' || rootName=='concat'}" @click="handleConcat()" >
  			<img src="../assets/img/concatactive.png" v-if="rootName=='concat' || rootName=='concat'"  >
        <img src="../assets/img/concat.png" v-else >
  			<span class="name">客服中心</span>
  			<img src="../assets/img/torightactive.png" v-if="rootName=='concat' || rootName=='concat'"  >
  			<img src="../assets/img/toright.png" v-else >
  		</div>
  		<div class="line">

  		</div>

  		<div class="text-center" style="margin-top: 15px;">
  			<img src="../assets/img/download.png" width="110">
  			<div class="font14">
  				下载APP
  			</div>
  		</div>
  		<div class="text-center">
  			<img src="../assets/img/kaozheng.jpeg" width="110">
  			<div class="font14">
  				在职考证
  			</div>
  		</div>
  		<div class="text-center">
  			<img src="../assets/img/kaoyan.jpeg" width="110">
  			<div class="font14">
  				在职考研
  			</div>
  		</div>
  		<div class="text-center" style="margin-bottom: 30px;">
  			<img src="../assets/img/onlineserve.jpeg" width="110">
  			<div class="font14">
  				联系客服
  			</div>
  		</div>
  </div>
</template>

<script>

  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
          showLogin:false,
          rootName:''
      }
    },
    methods:{
      handleMessage(){
        if(!window.sessionStorage.token){
          alert('请先登录')
          return;
        }
        this.$router.push('message')
      },
      handleNotice(){
        this.$router.push('noticelist')
      },
      handleAbout(){
        this.$router.push('about')
      },
      handleFeedback(){
        this.$router.push('feedback')
      },
      handleConcat(){
        this.$router.push('concat')
      }
    },
    created() {
      this.rootName=this.$route.name;
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/accountleft.vue